import React from 'react';

export default function MiniBanner() {
    return (
        <div className="mini-banner">
            <div className="main-heading">All Products</div>
            <div className="other-heading">A 360° look at Lumin</div>
        </div>
    );
}
